// Selection contract: submitted iOS58 AlbumDetailScreen, not API array order.
export function albumMemberReviews(reviews = [], myReviewId) {
  const byUser = new Map();
  const timestamp = (review) => Date.parse(review.createdAt) || 0;
  for (const review of reviews) {
    if (!review.content?.trim()) continue;
    const key = review.user?.id ?? `review:${review.id}`;
    const previous = byUser.get(key);
    if (
      !previous ||
      timestamp(review) > timestamp(previous) ||
      (timestamp(review) === timestamp(previous) && review.id > previous.id)
    )
      byUser.set(key, review);
  }
  const members = [...byUser.values()].sort((a, b) => timestamp(b) - timestamp(a) || b.id - a.id);
  return {
    count: members.length,
    publicReviews: members.filter((review) => review.id !== myReviewId),
  };
}
